if(!customElements.get('product-item')) {
  class ProductItem extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute('id');
      this.element = document.getElementById(`${this.id}`);
      this.imageWrapper = this.querySelector('.js-item-images');
      this.images = this.imageWrapper.querySelectorAll('img:not(.member-icon)');
      this.variantTitle = this.querySelector('.product-item__variant-title');
      this.swatches = this.querySelectorAll('.js-item-swatches input[type="radio"]');
      this.links = this.querySelectorAll('.js-link');
      this.variantInput = this.querySelector('.js-variant-input');
      this.mediaWrapper = this.querySelector('.product-item__image .media');
      this.imageData = [];
      this.flag = false;
    }

    changeForm(swatch) {
      if(!swatch || !this.variantInput) return;

      this.variantInput.value = swatch.getAttribute('data-js-variant-id');
    }

    updateLinkUrl(key, val, url) {
      const newUrl = new URL(url);
      newUrl.searchParams.set(key, val);
      return newUrl;
    }

    changeLinks(swatch) {
      if(!swatch) return;

      const url = swatch.getAttribute('data-js-variant-url');

      if(!url || !this.links) return;

      this.links.forEach((link) => { link.href = url; })
    }

    changeVariantTitle(swatch) {
      if(!swatch) return;
      if(!this.variantTitle) return;

      const newVariantTitle = swatch.getAttribute('data-js-variant-title');

      this.variantTitle.innerHTML = newVariantTitle;
    }

    async changeImageSource(swatch) {
      // console.log('product-item changeImageSource()', swatch);
      if(!swatch) return;

      swatch.setAttribute('checked', '');

      const productURL = swatch.getAttribute('data-js-variant-url');

      if(!productURL) return;

      await this.setImageData(productURL, swatch);
    }

    async setImageData(productURL, swatch = null) {
      try {
        const response = await fetch(`${productURL}&view=product-item-media`);
        const html = await response.text();

        // Create temporary element to parse HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const template = doc.querySelector('#item-media-template');

        if (template && this.mediaWrapper) {
          this.mediaWrapper.innerHTML = '';
          this.mediaWrapper.appendChild(template.content.cloneNode(true));

          // Update image references if needed
          this.images = this.imageWrapper.querySelectorAll('img:not(.member-icon)');
        }
      } catch (error) {
        console.error('Error updating product media:', error);
      }
    }

    toggleClasses() {
      if(this.flag == this.inside) return;
      if(this.images.length < 2) return;
      this.images.forEach((image) => { image.classList.toggle('hidden'); });
      this.flag = this.inside;
    }

    initSwatches() {
      // console.log('product-item initSwatches.');
      if(!this.swatches) return;
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', async (event) => {
          event.stopImmediatePropagation();
          // console.log('product-item Swatch click event.', event.target);
          await this.changeImageSource(swatch);
          this.changeVariantTitle(swatch);
          this.changeForm(swatch);
          this.changeLinks(swatch);
        });
      });
    }

    connectedCallback() {
      this.initSwatches();

      this.imageWrapper.addEventListener('mouseenter', () => {
        this.inside = true;
        this.toggleClasses();
      });

      this.imageWrapper.addEventListener('mouseleave', () => {
        this.inside = false;
        this.toggleClasses();
      });
    }
  }

  customElements.define('product-item', ProductItem);
}
